require("./bootstrap");
require("jquery-colorbox");
import "./formEvent";
import "./headerMenuEvent";
import "./sidemenuEvent";
import "./dispatchSchedule/schedule/date";
import "./dispatchSchedule/schedule/deliveryDestinationCopy";
import "./dispatchSchedule/schedule/driverNameCopy";
import "./dispatchSchedule/schedule/lineCopy";
import "./dispatchSchedule/schedule/submitCompleteForm";
// timePicker
import "jquery-timepicker/jquery.timepicker.css";
import "jquery-timepicker/jquery.timepicker";
import "./dispatchSchedule/schedule/timepicker/config";
// schedule
import "./dispatchSchedule/schedule/toggle/scheduleIndexCalendar";
// masterMaintenance
import "./masterMaintenance/car/carScratch/interior";
import "./masterMaintenance/car/carScratch/exterior";
